import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DisabledButtonTooltipCopy } from './DisabledButtonTooltipCopy';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConflictingTrialToolTip = ({
  apiName,
  conflictingTrials,
  children
}) => /*#__PURE__*/_jsx(Tooltip, {
  disabled: conflictingTrials.length === 0,
  placement: "bottom",
  title: /*#__PURE__*/_jsx(DisabledButtonTooltipCopy, {
    apiName: apiName,
    conflictingTrials: conflictingTrials
  }),
  children: children
});